// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","738":"course-manager","888":"course-setup"}[chunkId] || chunkId) + "." + {"160":"1b5211af","354":"024f89c5","368":"3fc598fe","579":"eea4ae27","598":"7c79a34f","624":"14d0b688","668":"f583838e","738":"b497fbaa","838":"3787910e","888":"7a871297"}[chunkId] + ".js";
};